import { render } from "./Rules.vue?vue&type=template&id=412aa0db"
import script from "./Rules.vue?vue&type=script&lang=ts"
export * from "./Rules.vue?vue&type=script&lang=ts"
script.render = render

export default script